import React from "react";
import { Navbar as NavigationBar, Container, Nav } from "react-bootstrap";
import { connect } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";

import "./Navbar.css";

function Navbar({ menu, auth }) {
  return (
    <>
      <NavigationBar className="navbar" expand="lg">
        <Container>
          <NavigationBar.Brand href='/'>
            <span className="brand">Keeper</span>
          </NavigationBar.Brand>
          <NavigationBar.Toggle aria-controls="basic-navbar-nav" />
          <NavigationBar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto nav-links">
              {auth.success === true ? (<LinkContainer to='/logout'><Nav.Link>Log Out</Nav.Link></LinkContainer>) : menu.map((item, idx) => (
                <LinkContainer key={idx} to={`${item.url}`}>
                  <Nav.Link>{item.name}</Nav.Link>
                </LinkContainer>
              ))}
            </Nav>
          </NavigationBar.Collapse>
        </Container>
      </NavigationBar>
    </>
  );
}

const mapStateToProps = state => ({
  auth: state.auth
})

export default connect(mapStateToProps, null)(Navbar);
